import { render, staticRenderFns } from "./WorkCategoryAttributeFilter.vue?vue&type=template&id=04f8b6fe"
import script from "./WorkCategoryAttributeFilter.vue?vue&type=script&lang=js"
export * from "./WorkCategoryAttributeFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports